import React from 'react';
import { FileProtectOutlined } from '@ant-design/icons';

function TrailerCard({ data }) {
  const mapData = [
    {
      label: 'Đã hết hạn',
      total: data?.ArrHetHanDangKiem?.length || 0,
      totalBg: 'danger',
      url: '/report-romooc?key=ArrHetHanDangKiem',
    },
    {
      label: 'Còn 10 ngày',
      total: data?.ArrHetHanDangKiem10?.length || 0,
      totalBg: 'orange',
      url: '/report-romooc?key=ArrHetHanDangKiem10',
    },
    {
      label: 'Còn 20 ngày',
      total: data?.ArrHetHanDangKiem20?.length || 0,
      totalBg: '',
      url: '/report-romooc?key=ArrHetHanDangKiem20',
    },

    {
      label: 'Còn 30 ngày',
      total: data?.ArrHetHanDangKiem30?.length || 0,
      totalBg: '',
      url: '/report-romooc?key=ArrHetHanDangKiem30',
    },
  ];

  return (
    <div className='card'>
      <div className='card-header'>
        <FileProtectOutlined className='card-icon green' />
        <h3 className='card-title'>Hạn Đăng Kiểm Romooc</h3>
      </div>

      {mapData.map((item) => {
        const clickable = item.total > 0;

        return (
          <div
            key={item.label}
            className={`row ${clickable ? 'clickable' : ''}`}
            onClick={clickable ? () => window.open(item.url, '_blank') : undefined}
          >
            <span>{item.label}</span>
            <b className={item.totalBg}>{item.total}</b>
          </div>
        );
      })}
    </div>
  );
}

export default TrailerCard;
